<template>
  <div>
    <div v-for="(items, index) in RowElement" :key="index">
      <div>
        <b-table
          responsive
          striped
          bordered
          :fields="items.fileditem"
          :items="items.responseItem"
          class="fraudReportHeaderTable"
        >
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    propertyTableData: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      firstTableItems: [],
      secondTableItems: [],
      thirdTableItems: [],
      fourthTableItems: [],
      firstTableFields: [
        {
          key: 'indexCol',
          label: '',
          class: 'font-weight-bold ',
          tdClass: 'textTruncatee',thStyle: { width: '200px' }
        },
        {
          key: 'subject',
          label: 'Subject',
          class: 'text-left ',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp1',
          label: 'Sale Comp-1',
          class: 'text-left ',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp2',
          label: 'Sale Comp-2',
          class: 'text-left ',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp3',
          label: 'Sale Comp-3',
          class: 'text-left ',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
      ],
      secondTableFields: [
        {
          key: 'indexCol',
          label: 'Value History',
          class: 'font-weight-bold',
          tdClass: 'textTruncatee',thStyle: { width: '200px' }
        },
        {
          key: 'subject',
          label: '',
          class: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp1',
          label: '',
          class: 'text-left ',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp2',
          label: '',
          class: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp3',
          label: '',
          class: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
      ],
      thirdTableFields: [
        {
          key: 'indexCol',
          label: 'Assessor Details',
          class: 'font-weight-bold',
          tdClass: 'textTruncatee',thStyle: { width: '200px' }
        },
        {
          key: 'subject',
          label: '',
          class: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp1',
          label: '',
          class: 'text-left ',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp2',
          label: '',
          class: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp3',
          label: '',
          class: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
      ],
      fourthTableFields: [
        {
          key: 'indexCol',
          label: 'Property Details',
          class: 'font-weight-bold',
          tdClass: 'textTruncatee',thStyle: { width: '200px' }
        },
        {
          key: 'subject',
          label: '',
          class: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp1',
          label: '',
          class: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp2',
          label: '',
          class: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
        {
          key: 'saleComp3',
          label: '',
          class: 'text-left ',
          tdClass: 'textTruncatee',thStyle: { width: '250px' }
        },
      ],
      rowIndex: 0,
      RowElement: [],
      firstRowElement: [
        'Address',
        'Distance(Miles)',
        'Subdivision',
        'APN',
        'Census Tract',
        'Distressed Flags',
      ],
      secondRowElement: [
        'Time-adjusted Value',
        'Total Adjustments',
        'Last Sale Price',
        'Last Sale Date',
        'Prior Sale Price',
        'Prior Sale Date',
        'List Price',
        'List Date',
        'Days on Market',
        'PSF (current)',
      ],
      thirdRowElement: [
        'Assessed Value',
        'Year',
        'Land Value',
        'Property Improvements',
      ],
      fourthRowElement: [
        'Style - Property Type',
        'Style - Design Style',
        'Interior - Finished (Sq Ft)',
        'Interior - Bsmnt (Sq Ft)',
        'Interior -Bsmnt Fnsh (Sq Ft)',
        'Interior - Bedrooms',
        'Interior - Bathrooms',
        'Exterior - Lot Size (acres)',
        'Amenties - Fireplaces',
        'Amenties - Pool',
        'Garage - Garage Spaces',
        'Garage - Garage Type',
        'Year Built',
        'Owner',
      ],
    }
  },
  created() {
    if (this.propertyTableData.length) {
      this.processFirstSectionData()
      this.processSecondSectionData()
      this.processThirdSectionData()
      this.processFourthSectionData()
      this.RowElement = [
        {
          fileditem: this.firstTableFields,
          responseItem: this.firstTableItems,
        },
        {
          fileditem: this.secondTableFields,
          responseItem: this.secondTableItems,
        },
        {
          fileditem: this.thirdTableFields,
          responseItem: this.thirdTableItems,
        },
        {
          fileditem: this.fourthTableFields,
          responseItem: this.fourthTableItems,
        },
      ]
    }
  },
  methods: {
    buildComparableMatrixColumns(data, FirstColItems) {
      var TableItems = []
      var subject = Object.values(data[0])
      var saleComp1 = Object.values(data[1])
      var saleComp2 = Object.values(data[2])
      var saleComp3 = Object.values(data[3])
      for (let index = 0; index < FirstColItems.length; index++) {
        TableItems.push({
          indexCol: this.formatDisplay(FirstColItems[this.rowIndex]),
          subject: this.formatDisplay(subject[index]),
          saleComp1: this.formatDisplay(saleComp1[index]),
          saleComp2: this.formatDisplay(saleComp2[index]),
          saleComp3: this.formatDisplay(saleComp3[index]),
        })
        this.rowIndex++
      }
      this.rowIndex = 0
      return TableItems
    },
    processFirstSectionData() {
      var data = []
      this.propertyTableData.forEach((items) => {
        data.push({
          address: items.address,
          distance: items.distance,
          subdivision: items.subdivision,
          apn: items.apn,
          censusTract: items.censusTract,
          distressedFlags: items.distressedFlags,
        })
      })
      this.firstTableItems = this.buildComparableMatrixColumns(
        data,
        this.firstRowElement
      ) // this.buildComparableMatrixColumns(data, First Column Items)
    },
    processSecondSectionData() {
      var data = []
      this.propertyTableData.forEach((items) => {
        data.push({
          timeAdjustedValue: items.timeAdjustedValue,
          totalAdjustments: items.totalAdjustments,
          lastSalePrice: items.lastSalePrice,
          lastSaleDate: items.lastSaleDate,
          priorSalePrice: items.priorSalePrice,
          priorSaleDate: items.priorSaleDate,
          listPrice: items.listPrice,
          listDate: items.listDate,
          daysOnMarket: items.daysOnMarket,
          psf: items.psf,
        })
      })
      this.secondTableItems = this.buildComparableMatrixColumns(
        data,
        this.secondRowElement
      ) // this.buildComparableMatrixColumns(data, First Column Items)
    },
    processThirdSectionData() {
      var data = []
      this.propertyTableData.forEach((items) => {
        data.push({
          assessedValue: items.assessedValue,
          year: items.year,
          landValue: items.landValue,
          propertyImprovement: items.propertyImprovement,
        })
      })
      this.thirdTableItems = this.buildComparableMatrixColumns(
        data,
        this.thirdRowElement
      ) // this.buildComparableMatrixColumns(data, First Column Items)
    },
    processFourthSectionData() {
      var data = []
      this.propertyTableData.forEach((items) => {
        data.push({
          stylePropertyType: items.stylePropertyType,
          styleDesignStyle: items.styleDesignStyle,
          interiorFinished: items.interiorFinished,
          interiorBasement: items.interiorBasement,
          interiorBasementFinish: items.interiorBasementFinish,
          interiorBedRooms: items.interiorBedRooms,
          interiorBathrooms: items.interiorBathrooms,
          exteriorLotSize: items.exteriorLotSize,
          amnetiesFirePlace: items.amnetiesFirePlace,
          amnetiesPool: items.amnetiesPool,
          garageSpace: items.garageSpace,
          garageSpaceType: items.garageSpaceType,
          yearBuilt: items.yearBuilt,
          owner: items.owner,
        })
      })
      this.fourthTableItems = this.buildComparableMatrixColumns(
        data,
        this.fourthRowElement
      ) // this.buildComparableMatrixColumns(data, First Column Items)
    },
    formatDisplay(value) {
      return value || null
    },
  },
}
</script>

<style scoped>
/* ::v-deep .table > thead > tr > th {
  background-color: whitesmoke;
} */
</style>
